import React from 'react'
import { renderWithRoot } from '../common/react-root-helper'
import { getState, subscribe } from '../store'
import appActions from '../actions/app'
import { getCategories } from './actions'
import App from '../common/app'
import Categories from './components/index'
let unsubscribe = function () {}

function render () {
  renderWithRoot(
    <App active="cart" {...getState()} {...appActions}>
      <Categories {...getState().categories} getCategories={getCategories} />
    </App>,
    document.querySelector('#app')
  )
}

export function enter (context, next) {
  unsubscribe = subscribe(render)
  getCategories()
  render()
}

export function exit (context, next) {
  unsubscribe()
  next()
}
